import _ from 'lodash';
export class LatLongColumnsComponent {
    key;
    label;
    title;
    type;
    columns;
    constructor(config = {}) {
        this.key = `LatLongColumns${config.key ? `-${config.key}` : ''}`;
        this.label = config.label || _.startCase(config.key);
        this.title = this.label;
        this.type = 'columns';
        const { required } = config.validate || {};
        this.columns = [
            {
                components: [
                    {
                        label: 'Latitude',
                        key: 'latitude',
                        type: 'number',
                        validate: {
                            min: -90,
                            max: 90,
                            ...required && { required }
                        }
                    },
                ],
                width: 6,
                size: 'md',
            },
            {
                components: [
                    {
                        label: 'Longitude',
                        key: 'longitude',
                        type: 'number',
                        validate: {
                            min: -180,
                            max: 180,
                            ...required && { required }
                        }
                    },
                ],
                width: 6,
                size: 'md',
            }
        ];
    }
}
